import { render, staticRenderFns } from "./cancelNotice.vue?vue&type=template&id=2e0d1e90&"
var script = {}
import style0 from "./cancelNotice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports